import React from 'react';
import { Users, X } from 'lucide-react';

const StatistiquesEnfants = ({ statsEnfants, filterNbEnfants, setFilterNbEnfants }) => {
  if (!statsEnfants || statsEnfants.length === 0) return null;

  const getColorClass = (nbEnfants) => {
    const colors = {
      0: 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200',
      1: 'bg-purple-100 text-purple-700 border-purple-300 hover:bg-purple-200',
      2: 'bg-blue-100 text-blue-700 border-blue-300 hover:bg-blue-200',
      3: 'bg-green-100 text-green-700 border-green-300 hover:bg-green-200',
      4: 'bg-yellow-100 text-yellow-700 border-yellow-300 hover:bg-yellow-200',
      5: 'bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200',
      6: 'bg-red-100 text-red-700 border-red-300 hover:bg-red-200'
    };
    return colors[nbEnfants] || 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center mb-4">
        <Users className="w-5 h-5 mr-2 text-[#246990]" />
        <h3 className="text-base font-semibold text-gray-700">
          Répartition par nombre d'enfants
        </h3>
      </div>
      
      <div className="grid grid-cols-5 gap-4">
        {statsEnfants.map((stat) => {
          const nbEnfants = parseInt(stat.nombre_enfants);
          const nbFamilles = parseInt(stat.nombre_familles);
          const isSelected = filterNbEnfants === nbEnfants;
          
          return (
            <button
              key={nbEnfants}
              onClick={() => setFilterNbEnfants(isSelected ? '' : nbEnfants)}
              className={`p-4 rounded-lg border-2 transition-all ${
                isSelected 
                  ? 'ring-2 ring-[#246990] ring-offset-2 shadow-lg' 
                  : 'shadow-sm hover:shadow-md'
              } ${getColorClass(nbEnfants)}`}
            >
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">
                  {nbFamilles}
                </div>
                <div className="text-sm font-medium leading-tight">
                  {nbFamilles === 1 ? 'famille' : 'familles'}
                  <br />
                  avec {nbEnfants} {nbEnfants <= 1 ? 'enfant' : 'enfants'}
                </div>
              </div>
            </button>
          );
        })}
      </div>
      
      {filterNbEnfants !== '' && (
        <div className="mt-4 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-3">
          <span className="text-sm text-blue-700 font-medium">
            Filtre actif : Familles avec {filterNbEnfants} {filterNbEnfants <= 1 ? 'enfant' : 'enfants'}
          </span>
          <button 
            onClick={() => setFilterNbEnfants('')} 
            className="text-sm text-blue-700 hover:text-blue-900 font-medium flex items-center bg-white px-3 py-1 rounded-md border border-blue-300 hover:bg-blue-100 transition-colors"
          >
            <X className="w-4 h-4 mr-1" />
            Réinitialiser
          </button>
        </div>
      )}
    </div>
  );
};

export default StatistiquesEnfants;